import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LossOfUseItemsDto, UomDto } from '@cradua/data';
import Swal from 'sweetalert2';
@Component({
  selector: 'cradua-loss-of-use-items',
  templateUrl: './loss-of-use-items.component.html',
  styleUrls: ['./loss-of-use-items.component.scss']
})
export class LossOfUseItemsComponent implements OnChanges {

  lossOfUseItemsForm: FormGroup;
  lossOfUseItemsFormArray: FormGroup;
  control = new FormControl();
  @Input() lossOfUseItemss: LossOfUseItemsDto[] = [];
  @Input() measurelist: UomDto[] = [];
  @Input() routeAnimationsElements: any;
  @Output() lossOfUseItems = new EventEmitter<LossOfUseItemsDto[]>()
  @Output() deleteLossOfUseItemsEvent = new EventEmitter<any>()

    selectedLossOfUseItems: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    UomName: string;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createLossOfUseItemsForm();

    }

    createLossOfUseItemsForm() {
      this.lossOfUseItemsForm = this.fb.group({
        LossOfUseItemDesc: ['', Validators.required],
        Rate: ['', Validators.required],
        UomId: [''],
        UomName: [''],
        Remarks: [''],
        id: null
        });
        this.lossOfUseItemsFormArray = this.fb.group({ LossOfUseItemss: this.fb.array([])
          });
        this.setLossOfUseItems();
    }

  // method to display LossOfUseItemss
  setLossOfUseItems() {
    const control  = this.lossOfUseItemsFormArray.controls.LossOfUseItemss as FormArray;
    this.lossOfUseItemss.forEach( e => {
      control.push(
        this.fb.group({
          LossOfUseItemDesc: e.LossOfUseItemDesc,
          Rate: e.Rate,
          UomId: e.UomId,
          UomName: e.UomName,
          // UomId: e.UomId,
          Remarks: e.Remarks,
          id: e.id
        })
      );
    });
  }

  onSelectLossOfUse(id: string) {
    this.UomName = this.measurelist.find(uom => uom.id === id)?.UomName || null;

  }

  // method to add LossOfUseItems
  addLossOfUseItems(value: LossOfUseItemsDto) {
    const control  = this.lossOfUseItemsFormArray.controls.LossOfUseItemss as FormArray;
    control.insert(0,
          this.fb.group({
            LossOfUseItemDesc: value.LossOfUseItemDesc,
            Rate: value.Rate,
            UomId: value.UomId,
            UomName: this.UomName,
            Remarks: value.Remarks,
            id: null
          })
       );
  }

  selectLossOfUseItems(value) {


  }

  getUOMName(id: string) {
    const found = this.measurelist.find(uom => uom.id === id);
   return found ? found.UomName : '';
  }

  // method to delete LossOfUseItems from arrary list
  deleteLossOfUseItems(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.lossOfUseItemsFormArray.controls.LossOfUseItemss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.lossOfUseItemss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.lossOfUseItemss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: LossOfUseItemsDto) {
    if(this.lossOfUseItemsForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.lossOfUseItemsFormArray.get('LossOfUseItemss')['controls'][this.selectedIndex].patchValue({
        LossOfUseItemDesc: formValue.LossOfUseItemDesc,
        Rate: formValue.Rate,
        Remarks: formValue.Remarks,
        UomName: this.UomName != null ? this.UomName : formValue.UomName,
        UomId: formValue.UomId,
      });
    } else {
      this.addLossOfUseItems(formValue);
    }
    this.selectedIndex = null;
    this.lossOfUseItemsForm.reset()
  }

  onEdit(index, value: LossOfUseItemsDto) {
    this.selectedIndex = index;
    this.lossOfUseItemsForm.patchValue(value);
  }

  onClearForm() {
    this.selectedIndex = null;
    this.lossOfUseItemsForm.reset();
  }

  onSubmit(formValue: LossOfUseItemsDto[]) {
  this.lossOfUseItems.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteLossOfUseItemsEvent.emit(this.filteredDelete);
  }
  }


}
